import { render, staticRenderFns } from "./PostsCalendar.vue?vue&type=template&id=6f3241ee&scoped=true&"
import script from "./PostsCalendar.vue?vue&type=script&lang=js&"
export * from "./PostsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PostsCalendar.vue?vue&type=style&index=0&id=6f3241ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3241ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3241ee')) {
      api.createRecord('6f3241ee', component.options)
    } else {
      api.reload('6f3241ee', component.options)
    }
    module.hot.accept("./PostsCalendar.vue?vue&type=template&id=6f3241ee&scoped=true&", function () {
      api.rerender('6f3241ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/social-media-posting/PostsCalendar.vue"
export default component.exports